import api from '@/services/api';
import { mapInvoice } from './agreements';
import type { AgreementInvoice } from '../types/agreements.types';

export const reverseInvoice = async (
    agreementId: string,
    invoiceId: string,
    note: string,
): Promise<AgreementInvoice> => {
    const response = await api.post(
        `/invoicing/agreements/${agreementId}/invoices/${invoiceId}/reverse`,
        { note },
        { suppressGlobalForbiddenToast: true },
    );
    const raw = response.data.data;
    return mapInvoice(raw as Record<string, unknown>);
};
